/**
 * The single place to customise the portal's look. To rebrand, edit the colours below and replace
 * the files in `public/brand/` (and `public/favicon.*`, `public/apple-touch-icon.png`,
 * `public/android-chrome-192x192.png`, `public/safari-pinned-tab.svg`) - no other code changes.
 * The portal title is `app.title` in app-config.yaml.
 */
export const brand = {
  /** Wide logo shown in the expanded sidebar; any height-agnostic SVG/PNG. */
  logoFull: '/brand/logo-full.svg',
  /** Square-ish mark shown in the collapsed sidebar. */
  logoIcon: '/brand/logo-icon.svg',
  /** Loaded from Google Fonts in `public/index.html`; the fallbacks apply until it arrives. */
  fontFamily: '"DM Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  colors: {
    /** Primary brand colour: links, buttons, selected states. */
    primary: { light: '#2e7d32', dark: '#c6f68d' },
    /** Sidebar background and the page header banner. */
    navBackground: { light: '#1e2b26', dark: '#1e2b26' },
    /** Accent used for the sidebar's selected-item indicator. */
    navIndicator: { light: '#c6f68d', dark: '#c6f68d' },
  },
};
